import { BrightFutureTogether } from "../../BlogPage/BrightFutureTogether"
import { Footer } from "../../Footer"
import { Header } from "../../Header"
import { HeroSection } from "../../HeroSection"
import { InfoCustomizedSolution } from "./InfoCustomizedSolution"

export const CustomizedSolution =()=>{
    return(
        <>
       <Header active="Home"/>
            <HeroSection/>
            <InfoCustomizedSolution/>
            <BrightFutureTogether/>
            <Footer/>
        </>
    )
}